export default (str) => {
  return str.split(" ").map(el => el.charAt(0)).join("");
}
